import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { SEO } from "@/components/SEO";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PolicyPage({ slug: slugProp }) {
  const params = useParams();
  const slug = slugProp || params.slug;
  const [page, setPage] = useState(null);
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    setPage(null);
    setLoadFailed(false);
    axios.get(`${API}/api/legal-pages/${slug}`).then((r) => setPage(r.data)).catch((err) => { console.error(err); setLoadFailed(true); });
  }, [slug]);

  if (loadFailed) {
    return (
      <div className="container-x py-32 text-center" data-testid="policy-page-load-error">
        <p className="text-white/70 font-mono text-sm mb-3">Couldn't load this page. Please check your connection and try again.</p>
        <button type="button" onClick={() => window.location.reload()} className="text-[var(--brand-primary)] underline text-sm" data-testid="policy-page-retry-button">Retry</button>
      </div>
    );
  }

  if (!page) return <div className="container-x py-32" data-testid="policy-page-loading" />;

  return (
    <div data-testid="policy-page" className="container-x py-24 md:py-32">
      <SEO path={`/${slug}`} title={`${page.title} — XpeditioNZ`} description={page.sections[0]?.body || page.title} />
      <p className="overline mb-4">— Legal</p>
      <h1 className="font-display text-4xl md:text-6xl text-white leading-[0.95] mb-4" data-testid="policy-page-title">
        {page.title}
      </h1>
      {page.updatedAt && (
        <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-white/40 mb-16">
          Last updated {new Date(page.updatedAt).toLocaleDateString("en-NZ", { day: "numeric", month: "long", year: "numeric" })}
        </p>
      )}
      <div className="max-w-3xl space-y-12">
        {page.sections.map((section, i) => (
          <div key={i} data-testid={`policy-section-${i}`}>
            {section.heading && <h2 className="font-display text-2xl text-white mb-3">{section.heading}</h2>}
            {section.body && section.body.split("\n\n").map((para, pi) => (
              <p key={pi} className="text-[var(--text-secondary)] text-lg leading-relaxed mb-4 last:mb-0">{para}</p>
            ))}
            {section.bullets?.length > 0 && (
              <ul className="mt-4 space-y-2">
                {section.bullets.map((b, bi) => (
                  <li key={bi} className="flex items-start gap-3 text-[var(--text-secondary)] text-base leading-relaxed">
                    <span className="mt-2.5 w-1.5 h-1.5 bg-[var(--brand-primary)] shrink-0" />
                    {b}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
